// Whatsapp js 
  function toggleChat() {
    var chatBox = document.getElementById("chatBox");
    chatBox.style.display = chatBox.style.display === "block" ? "none" : "block";
  }

  function sendMessage() {
    var msg = document.getElementById("whatsappMessage").value.trim();
    if (msg.length > 0) {
      var url = "https://wa.me/13124933343?text=" + encodeURIComponent(msg);
      window.open(url, '_blank');
    } else {
      alert("Please type a message.");
    }
  }
// Whatsapp js end
// ----------------country code-----------------
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form');
  const countryCode = document.getElementById('country_code');
  const phoneInput = document.getElementById('ContactForm-phone');
  const preview = document.getElementById('full-number-preview');

  if (!form || !countryCode || !phoneInput || !preview) return;

  // Create hidden input for combined value
  const hidden = document.createElement('input');
  hidden.type = 'hidden';
  hidden.name = 'contact[full_phone]';
  form.appendChild(hidden);

  // Function to update both preview and hidden field
  function updateFullPhone() {
    const code = countryCode.value;
    const phone = phoneInput.value.trim();
    const fullPhone = `${code} ${phone}`;
    
    if (phone) {
      preview.textContent = fullPhone;
      hidden.value = fullPhone;
    } else {
      preview.textContent = '';
      hidden.value = '';
    }
  }

  // Update on typing or changing country
  countryCode.addEventListener('change', updateFullPhone);
  phoneInput.addEventListener('input', updateFullPhone);

  // Update again just before form submits
  form.addEventListener('submit', function () {
    updateFullPhone();
  });
});

// hover on off menu submenu settigns start

document.querySelectorAll("header-menu details").forEach((menu) => {
  menu.addEventListener("mouseenter", () => {
    menu.setAttribute("open", "");
    menu.querySelector("summary").setAttribute("aria-expanded", "true");
  });
  menu.addEventListener("mouseleave", () => {
    menu.removeAttribute("open");
    menu.querySelector("summary").setAttribute("aria-expanded", "false");
  });
});

// hover on off menu submenu settigns end